import { render, staticRenderFns } from "./AppointmentDetailV2.vue?vue&type=template&id=20a6e97f"
import script from "./AppointmentDetailV2.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports